// Emptystring is not valid alias for name or description.
export const normalizeAlias = (alternateNameOrDescription?: string): string | undefined => {
	if (alternateNameOrDescription === '') {
		return undefined;
	}
	return alternateNameOrDescription;
};
